import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import CardsQuestionBuilder from '@ignitesales/react-card-question-builder';
import {actions} from '@ignitesales/react-card-question-builder/src/actions';
import {showValidationErrors} from '../../../actions/validation-action-creators';
import {builderAnswerChanged, builderGroupValidation, builderQuestionValidation} from '../../../actions/question-action-creators';
import {BuilderConnectedPropTypes} from '../../../shapes/index';
import builderRenderLinkedQuestion from '../../../util/builderRenderLinkedQuestion.mjs';
import PropTypes from 'prop-types';

const CardBuilderConnected = props => {
  const {
    builderLinkedQuestions,
    builderOptions,
    filteredOptions,
    linkedQuestionValueChanged,
    onAdd,
    onRemove,
    renderLinkedQuestion,
    renderOptions,
    validateBuilder,
    value,
    validationErrors = [],
    onDisabledClick,
    ...rest
  } = props;

  useEffect(() => {
    validateBuilder(currentValues);
  }, []);

  useEffect(() => {
    setDisabledBuilder((currentValues || []).includes(builderOptionsToggleNoneKey));
  }, [value]);

  const { value: currentValues = [] } = value || {};
  const [activeCard, setActiveCard] = useState(false);
  const [disabledBuilder, setDisabledBuilder] = useState(false);
  const builderOptionsToggleNoneKey = (builderOptions.attributes || {}).toggleNone || false;

  const renderBuilderOptionsQuestion = () => {
    const onCardOptionsValueChange = ({value, valueChanged}) => {
      const optionHasBeenAdded = Array.isArray(value) ? value.length > currentValues.length : value;
      const toggleNoneHasBeenAdded = builderOptionsToggleNoneKey && Array.isArray(value) && value.includes(builderOptionsToggleNoneKey);
      if (toggleNoneHasBeenAdded){
        currentValues.map(v => onRemove({appkey: v, currentValues}));
        setActiveCard(false);
      }else if(optionHasBeenAdded){
        const selectedOptionAppKey = Array.isArray(value) ? value[value.length - 1] : value;
        const doesCardExist = builderLinkedQuestions.find( ({id}) => id === selectedOptionAppKey);
        if(doesCardExist){
          setActiveCard(selectedOptionAppKey);
        }
      }
      validateBuilder(value);
      valueChanged(value);
    };

    return renderOptions({
      ...filteredOptions,
      attributes: {
        ...(builderOptions.attributes || {}),
        valueChanged: onCardOptionsValueChange
      }
    });
  };

  const hasErrorsInCard = card => {
    const validationErrorQuestionAppKeys = validationErrors.filter(v => v?.fieldType === 'question').map(v => v?.key);
    const cardQuestionsWithErrors = (card?.questions || []).filter(q => validationErrorQuestionAppKeys.includes(q?.appkey));
    return cardQuestionsWithErrors.length > 0;
  };

  const onChange = ({card, action}) => {
    switch (action) {
      case actions.CARD_SAVED: {
        onDisabledClick();
        if (!hasErrorsInCard(card)) {
          setActiveCard(false);
        }
        break;
      }
      case actions.MODAL_CLOSED: {
        setActiveCard(false);
        break;
      }
      case actions.CARD_ADDED: {
        setActiveCard(card.id);
        onAdd({
          appkey: card.id,
          currentValues
        });
        break;
      }
      case actions.CARD_REMOVED: {
        setActiveCard(false);
        onRemove({
          appkey: card.id,
          currentValues
        });
        break;
      }
      case actions.EDIT: {
        setActiveCard(card.id);
        break;
      }
      default:
        break;
    }
  };

  return <CardsQuestionBuilder
    {...rest}
    cards={ builderLinkedQuestions }
    disabled={disabledBuilder}
    onChange={ onChange }
    values={ currentValues }
    activeCardId={ activeCard }
    renderQuestion={linkedQuestion => builderRenderLinkedQuestion(linkedQuestion, linkedQuestionValueChanged, renderLinkedQuestion)}
    renderOptions={renderBuilderOptionsQuestion}
  />;
};

CardBuilderConnected.propTypes = {
  ...BuilderConnectedPropTypes,
  renderOptions: PropTypes.func.isRequired
};

export default connect(
  ({ answers, validationErrors }, { builderOptions }) => {
    return {
      value: answers[builderOptions.appkey],
      answers,
      validationErrors,
    };
  },
  (dispatch, { questionGroup, builderOptions: question }) => {
    return {
      onAdd: ({ appkey, currentValues }) => {
        const value = [ ...currentValues.filter(v => v !== appkey), appkey ];
        dispatch( builderAnswerChanged({ question, questionGroup, value }) );
      },
      onRemove: ({ appkey, currentValues }) => {
        const value = currentValues.filter(v => v !== appkey);
        dispatch( builderAnswerChanged({ question, questionGroup, value, hasBeenRemoved: appkey }) );
      },
      linkedQuestionValueChanged: linkedQuestion => {
        dispatch( builderQuestionValidation({linkedQuestion, questionGroup, shouldDisplay: true}) );
      },
      validateBuilder: value => {
        dispatch( builderGroupValidation({questionGroup, question, value}) );
      },
      onDisabledClick: () => {
        dispatch(showValidationErrors());
      },
    };
  },
)(CardBuilderConnected);
